import React, { useState } from 'react'
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { useUsers } from '../../CustomHooks/useUsers'
import { ALLALERTS } from '../../navigation/CONSTANTS'
import { useHistory } from 'react-router-dom'
import Swal from 'sweetalert2'
import { addrasaconversationindb, alertReassign } from '../../services/chatFlowService'
import { SuccessToast } from '../../CustomHooks/SuccessToast'
import { Reassign } from '../../assets/images'
import { ConvertDate, multiTimeZoneHelper } from '../../utils/utils'
import { MULTI_TIME_ZONE } from '../../config'
import { useActiveUsers } from '../../CustomHooks/useActiveUsers'
import { ErrorToast } from '../../CustomHooks/ErrorToast'

let OFFSET_MINUTES = 330;

const AlertReassign = React.memo(({ alertId, rasaConversationId, parent, callFromParent, details }) => {
    
    let loggedInUser = JSON.parse(localStorage.getItem('user'))
    const [display, setDisplay] = useState(false)
    const [disabledBtn, setDisabledBtn] = useState(false);
    const [selectedUser, setSelectedUser] = useState("");
    // const { users } = useUsers()
    const { activeUsers, getUsers } = useActiveUsers(alertId)
    let history = useHistory()

    const getDate = () => {
        let d;
        if (MULTI_TIME_ZONE) {
            let offsetTemp = details.OffsetMinutes != null ? details.OffsetMinutes : OFFSET_MINUTES
            d = multiTimeZoneHelper(offsetTemp);
        } else {
            d = new Date();
        }
        return d
    }

    const reassignHandler = async (e) => {
        let loggedInUser = JSON.parse(localStorage.getItem('user'))
        console.log("Reassign- assign to", selectedUser);
        console.log("Reassign- assign from", loggedInUser?.Id);
        console.log("Reassign- alertId", alertId);
        console.log("Reassign- rasaConversationId", rasaConversationId);

        await Swal.fire({
            title: "Are you sure?",
            text: "Do you want to reassign the alert.",
            icon: 'info',
            showCancelButton: true,
            confirmButtonColor: "#027aaa",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, reassign!",
        }).then((result) => {
            if (result.isConfirmed) {
                setDisabledBtn(true)
                let assignedFrom = loggedInUser?.FullName;
                let assignedTo = activeUsers.find((item) => item.ID == selectedUser)?.FullName
                let text = `Alert reassigned by ${assignedFrom} to ${assignedTo}.`
                let d = getDate();
                let myCurrentDatetime = d;
                let _datetime = ConvertDate(myCurrentDatetime)
                let rasaconvobj = {
                    "evidenceType": "comment",
                    "text": `${text}`,
                    "timestamp": _datetime,
                    "type": "user"
                }
                addrasaconversationindb({
                    "assignedTo": loggedInUser?.Id,
                    "rasaConversationID": rasaConversationId,
                    "uploadType": "file",
                    "evidence": rasaconvobj,
                    "conversation": null,
                    "userType": "operator",
                    "createdOn": _datetime,
                    "username": loggedInUser?.FullName
                }).then((resp) => {
                    if (resp.Status === "Ok") {
                        alertReassign(loggedInUser?.Id, alertId, selectedUser, rasaConversationId)
                            .then((res) => {
                                if (res.Status == "success") {
                                    SuccessToast(res.Message);
                                    setDisabledBtn(false)
                                    if (parent === 'CHATBOT') {
                                        callFromParent(e);
                                    } else if (parent === 'ALERTGRIDVIEW') {
                                        callFromParent(alertId)
                                    }
                                    else {
                                        history.push(ALLALERTS)
                                    }
                                }else{
                                    ErrorToast(res.Message);
                                    setDisabledBtn(false)
                                    if (parent === 'CHATBOT') {
                                        callFromParent(e);
                                    } else if (parent === 'ALERTGRIDVIEW') {
                                        callFromParent(alertId)
                                    }
                                    else {
                                        history.push(ALLALERTS)
                                    }
                                }
                            }).catch(err => {
                                setDisabledBtn(false)
                                console.log(err);
                            });
                    }else{
                        setDisabledBtn(false)
                    }
                }).catch(err => {
                    console.log(err)
                    setDisabledBtn(false)
                });

            } else {
                setDisabledBtn(false)
                return;
            }
        })
    }

    const reassignModal = (e) => {
        console.log("reassignModal", e)
        e.stopPropagation();
        getUsers(alertId);
        setDisplay(true);
    }

    const closeModal = (e) => {
        setSelectedUser("");
        setDisplay(false)
    }

    const handleSelectedUser = (e) => {
        console.log("reassignModal", e)
        e.stopPropagation();
        setSelectedUser(e.target.value);
    }
    return (
        <>
            <div>
                {/* <button className="" onClick={(e) => reassignModal(e)}>
                    Reassign
                </button> */}
                <OverlayTrigger
                    placement="auto"
                    overlay={<Tooltip style={{zIndex: 99999 }}>Reassign</Tooltip>}                
                >
                    <button
                    className="TwoWayAudioToggle two-way-and-hooter-on-off"
                    onClick={(e) => reassignModal(e)}
                    disabled={details?.alertStatus == "Closed"}
                    >
                        <img
                          style={{ padding: "2px", height: "26px" }}
                          src={Reassign}
                          alt="reassign icon"
                        />
                    </button>
                </OverlayTrigger>
            </div>
            <div style={{zIndex:'99999'}} onClick={(e) => e.stopPropagation()}>
            <Modal style={{zIndex:'99999'}} show={display} onHide={(e) => closeModal(e)} size='xl' >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <p>Alert reassignment of alert - {alertId}</p>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div 
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        margin: '1rem'
                    }}
                    >
                        <div className="inputMainContainer w40dot75rem mt35">
                            <div className="inputTypeLabelContainer">
                                <label className='formFieldLabels'>Reassign alert to</label>
                                <select
                                    className="inputType ArrowSelectClass"
                                    onChange={(e) => handleSelectedUser(e)}
                                >
                                    <option key="0" disabled={false} value="" id="0">Select User</option>
                                    {activeUsers &&
                                        activeUsers.filter(item => item?.ID != loggedInUser?.Id).map((val) => (
                                            <option value={val.ID} key={val.ID} ID={val.ID}>
                                                {val?.FullName} - {val?.RoleName}
                                            </option>
                                        ))}
                                </select>
                            </div>
                        </div>
                        <div>
                        <button disabled={selectedUser === "" || disabledBtn} className="DataAccessEdit" style={{ width: "100px" }} onClick={(e) => reassignHandler(e)}>
                            <span className="ViewUpdate">Reassign</span>
                        </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            </div>

        </>
    )
})

export default AlertReassign